import { render, staticRenderFns } from "./Editor.vue?vue&type=template&id=671f7b68&"
import script from "./Editor.vue?vue&type=script&lang=js&"
export * from "./Editor.vue?vue&type=script&lang=js&"
import style0 from "./Editor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Editor.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Editor.vue
// module id = 2290
// module chunks = 1